import { Button } from "primereact/button";
import NewCreateInvoiceItems from "./new-create-invoice-items";
import NewCreateInvoiceTop from "./new-create-invoice-top";
import { useEffect, useState, useCallback } from "react";
import NewInvoicePayment from "./new-invoice-payment";
import '../../assests/css/common/responsive-ui.css'
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import orderServices from '../../services/orders/orderservice';
import { POSModel } from '../../models/orders/order-list-model';
import { Dialog } from "primereact/dialog";
import { NewAddProduct } from "./new-add-product";

const NewCreateInvoice = (props: any) => {
  const [invoiceCheckoutItem, setInvoiceCheckoutItem] = useState<any>(null);
  const [paymentModeId, setPaymentModeId] = useState<number | null>(null);
  const [isPaymentModeSelected, setIsPaymentModeSelected] = useState(false);
  const [paymentModeError, setPaymentModeError] = useState(false);
  const [pointOfSale, setPointOfSale] = useState<number>();
  const [posData, setPOSData] = useState<POSModel[]>([]);
  const [posCodes, setPosCodes] = useState<{name: string, code: number}[]>([]);
  const [selectedAddr, setSelectedAddr] = useState("");
  const [isInvoiceCreating, setIsInvoiceCreating] = useState(false);
  const [addProductVisible, setAddProductVisible] = useState(false);
  const [isPOSSelected, setIsPOSSelected] = useState(false);
  const [showpaymentOptions, setShowpaymentOptions] = useState<boolean>(true);
  const [isOrderDataEmpty, setIsOrderDataEmpty] = useState(true);
  const [hasInsufficientStock, setHasInsufficientStock] = useState(false);

  const handleCreateInvoice = async () => {

    if (showpaymentOptions && !isPaymentModeSelected) {
      setPaymentModeError(true);
      return;
    }

    try {
      setIsInvoiceCreating(true);
      await props.runCreateInvoice(invoiceCheckoutItem, paymentModeId);
      props.runHideDialog();
    } catch (error) {
      console.error("Error at Create Invoice:", error);
     } 
    finally {
      setIsInvoiceCreating(false);
    }
  };

  const handleOrderDataEmptyChange = useCallback((isEmpty: boolean) => {
    setIsOrderDataEmpty(isEmpty);
  }, []);

  const handlePOSChange = useCallback((e: DropdownChangeEvent) => {
    const selectedValue = e.value;
    setPointOfSale(selectedValue);
    setIsPOSSelected(!!selectedValue); 
    
    setInvoiceCheckoutItem((prevState: any) => ({
      ...prevState,
      posID: selectedValue
    }));

    const filteredPOS = posData.filter(item => item.posID === selectedValue);
    const addressData = filteredPOS.map(item => {
      return [
        item.address1,
        item.address2,
        item.landmark,
        item.cityName,
        item.stateName,
        item.zipcode ? `Pin: ${item.zipcode}` : ''
      ].filter(Boolean).join(", ");
    });
    setSelectedAddr(addressData[0] || "");
  }, [posData]);

  const getALLPOS = useCallback(() => {
    orderServices.getPOS().then((response: POSModel[]) => {
      setPOSData(response);
      const posCodes = response.map(item => ({ name: item.posCode, code: item.posID }));
      setPosCodes(posCodes);
      if (response.length === 1) {
        const singlePOS = response[0];
        setPointOfSale(singlePOS.posID);
        setIsPOSSelected(true);
        
        setInvoiceCheckoutItem((prevState: any) => ({
          ...prevState,
          posID: singlePOS.posID
        }));
        
        let addressData = 
          (singlePOS.address1 ? singlePOS.address1 + ", " : "") +
          (singlePOS.address2 ? singlePOS.address2 + ", " : "") +
          (singlePOS.landmark ? singlePOS.landmark + ", " : "") +
          (singlePOS.cityName ? singlePOS.cityName + ", " : "") +
          (singlePOS.stateName ? singlePOS.stateName + ", " : "") +
          (singlePOS.zipcode ? "Pin: " + singlePOS.zipcode : "");
        
        setSelectedAddr(addressData.trim());
      }
    }).catch(error => {
      console.error("Error fetching POS:", error);
    });
  }, []);

  const updateItem = useCallback((newItems: any, taxableAmt: number, taxAmt: number, disAmt: number) => {
    setInvoiceCheckoutItem((prevState: any) => ({
      ...prevState, 
      orderDetails: newItems,
      taxableAmount: Math.round(taxableAmt * 100) / 100,
      taxAmount: Math.round(taxAmt * 100) / 100, 
      discountAmount: disAmt
    }));
  }, []);

  const updateItemAfterAdd = (newItems: any) => {
    console.log('New items received:', newItems);
    setInvoiceCheckoutItem((prevState: any) => {
      const updatedOrderDetails = [...newItems.orderDetails];
      console.log('Updated order details:', updatedOrderDetails);
      const updatedState = {
        ...prevState,
        orderDetails: updatedOrderDetails
      };  
      props.setOrderData(updatedState);
      return updatedState;
    });
  };

  const handlePaymentModeChange = useCallback((id: number | null) => {
    setPaymentModeId(id);
    setIsPaymentModeSelected(id !== null);
    setPaymentModeError(false); 
  }, []);

  useEffect(() => {
    const initialData = {
      ...props.OrderData,
      orderDetails: props.OrderData.orderDetails || []
    };
    setInvoiceCheckoutItem(initialData);
    
    if (props.OrderData.paymentAlreadyCharged == true) {    
        setShowpaymentOptions(false);
        setPaymentModeId(props.OrderData.payId);
        setIsPaymentModeSelected(true);    
    }
    getALLPOS();
  }, [props.OrderData, getALLPOS]);

 
const handleInsufficientStock = useCallback((isInsufficient: boolean) => {
    setHasInsufficientStock(isInsufficient);
  }, []);

  const isGenerateDisabled = !isPOSSelected || isInvoiceCreating || isOrderDataEmpty || !isPaymentModeSelected || hasInsufficientStock;
  return (
    <>
      <div className="flex flex-column border-1 surface-border box-shadow-none m-0">
        <NewCreateInvoiceTop orderData={props.OrderData} />       
        <div className="flex pl-3 mb-3 col-12 sm:col-12 lg:col-12 border-round">
          <p className="pos-text mt-3 font-bold">Point Of Sale: </p> <span className="required">*</span>
          <div className="ml-4 lg:col-3">
            <Dropdown
              options={posCodes}
              optionLabel="name"
              optionValue="code"
              value={pointOfSale}
              onChange={handlePOSChange}
              placeholder="Select POS"
              style={{ width: "100%" }}
              required
              className={!isPOSSelected && pointOfSale === undefined ? "p-invalid" : ""}
            />
            {!isPOSSelected && pointOfSale === undefined && (
              <small className="p-error">POS is required</small>
            )}
          </div>
          <p className="ml-4 mt-2">{selectedAddr}</p>
        </div>

        {showpaymentOptions && props.OrderData.paymentAlreadyCharged === false && (
          <>
            <div className="pl-3 mb-3">
              <div className="flex align-items-center">
                <p className="pos-text mt-3 font-bold">Select Payment Mode: </p>
                <span className="required">*</span>
              </div>
              <NewInvoicePayment updatePaymentId={handlePaymentModeChange} />
              {paymentModeError && (
                <small className="p-error">Payment mode is required</small>
              )}
              <br />
            </div>
            <div>
              <div className="ml-3">
                <Button label="Add Product" onClick={() => setAddProductVisible(!props.OrderData.paymentAlreadyCharged)} />
              </div>
              <Dialog
                header="Add Product"
                visible={addProductVisible}
                style={{ width: "67vw" }}
                onHide={() => setAddProductVisible(false)}
                className="addProduct-dialog"
              >
                <NewAddProduct
                  orderedItems={invoiceCheckoutItem}
                  updateItems={updateItemAfterAdd}
                />
              </Dialog>
            </div>
          </>
        )}

        <NewCreateInvoiceItems
          key={JSON.stringify(invoiceCheckoutItem?.orderDetail)}
          orderedItems={invoiceCheckoutItem}
          updateItems={updateItem} 
          onOrderDataEmptyChange={handleOrderDataEmptyChange}
          onInsufficientStockChange={handleInsufficientStock} 
        />
      </div>

      <div className="flex justify-content-end flex-wrap mt-2">
        <Button
          label="Close"
          className="border-round mt-2 ml-2 responsive-button"
          onClick={props.runHideDialog}
          style={{ width: "20%", textAlign: 'center' }}
          severity="warning"
        />
        <Button
          label={isInvoiceCreating ? "Processing..." : "Generate Invoice"}
          className="border-round mt-2 ml-2 responsive-button"
          onClick={handleCreateInvoice}
          style={{ width: "20%", textAlign: 'center' }}
          severity="success"
          disabled={isGenerateDisabled}
        />
      </div>
    </>
  );
};

export default NewCreateInvoice;